import React, {useState} from 'react';
import TextBox from '../components/textbox';
import Button from '../components/button';
import '../styling/containerStyles.css';
import Label from '../components/label';
import codeValid from '../assets/images/codeValid.png';
import codeInvalid from '../assets/images/codeInvalid.png';
import SimpleCaptcha from '../simpleCaptcha';
import codeUsed from '../assets/images/codeUsed.png'
import codeDeactivate from '../assets/images/codeDeactivate.png'

interface VerifyNumberProps{
    scan: boolean;
    msgPh?:string;
    handleToUpdateVerified:Function;
    banner: any;
    subBanner: any;
    codeScanStatusCode : any;
}

export const VerifyNumber: React.FC<VerifyNumberProps> = (props: VerifyNumberProps) =>{

    const{
        handleToUpdateVerified, scan, msgPh, banner, subBanner , codeScanStatusCode
    } = props;

    const [phoneNo, setPhoneNo] = useState('')
    const [message, setMessage] = useState('')
    const handleToUpdateContent = (name:string, arg:string) => {
        if(name === 'phoneNo'){
            setPhoneNo(arg)
        }

    }

    const handleToUpdateNumber = (arg:string) => {
        if(scan === true){ 
            var re = /^[0-9]{10}$/;
            if(re.test(phoneNo) )
                handleToUpdateVerified(phoneNo)
            else{
                setMessage('Please enter a valid number')
                setPhoneNo('')
            }
        }
    }
        return (
            <div className='homeWrap section-space-between'>
                <div className='homeTop'>
                    <div className='homeTopBanner'>
                        <img src={banner} alt='Pidilite Top Banner' className='pidiliteTopBanner'/>
                    </div>
                </div>
                

                <div className='home home-verify-number'>
                    {scan &&
                    <div className='verifyNumberPage'>
                        <img src={codeValid} alt='code valid' className='codeValidImg'/>
                        <div className='verifyNumberImg'> </div>
                        <div className='productImageWrap'>
                            <img src={subBanner} alt='Product Image' className='productImage'/>
                        </div>
                        <div className='verifyNumber'>
                            
                            <Label content='Verify Number' />

                            <TextBox className='textBox'
                                    label={''} 
                                    state={'phoneNo'}
                                    placeholder={'Enter registered contact number'} 
                                    handleToUpdate={handleToUpdateContent}
                            />

                            <div className='message'>{msgPh}</div>
                            <div className='message'>{message}</div>

                            {phoneNo === localStorage.getItem('phone_number') ?
                            null
                            :
                            <Button label= {'Enter your mobile number'} 
                                    name={'VERIFY'} 
                                    visible={true}
                                    handleToUpdate={handleToUpdateNumber}  />
                            }

                        </div>
                        {phoneNo === localStorage.getItem('phone_number') ?
                        <SimpleCaptcha phoneNo={phoneNo} handleToUpdateNumber={handleToUpdateNumber} />
                        :
                        null}
                    </div>   
                    }
                    {   
                        !scan &&
                        <div className='verifyNumberPage'>
                            <div className='productImageWrap'>
                                <img src={subBanner} alt='Product Image' className='productImage'/>
                            </div>
                            {codeScanStatusCode === 901 ? <img src={codeUsed} alt='code valid' className='codeValidImg' /> :
                            codeScanStatusCode === 903 ? <img src={codeDeactivate} alt='code valid' className='codeValidImg deactivate'/> :
                            codeScanStatusCode !== 901 && <img src={codeInvalid} alt='code valid' className='codeValidImg'/>
                            }
                             
                            {/* <div className='error-btn-wrap'>
                                <Button label= {'SCAN AGAIN'} 
                                        name={'SCAN AGAIN'} 
                                        visible={true}
                                        handleToUpdate={handleToUpdateNumber}  />
                            </div> */}
                        </div>      
                    }
                </div>  
            </div>           
        )
    }

export default VerifyNumber